import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setAccessToken} from "../slices/authSlice";
import {TabsContext, TabsList, TabsTab, TabsPanel} from "@seismic/mantle";
import {useUserCommands} from "../hooks/userCommands";
import {IbmTab} from "../components/IbmTab";
import {MeetingOverviewTab} from "../components/MeetingOverviewTab";
import {GptTab} from "../components/GptTab";
import {MicrosoftTab} from "../components/MicrosoftTab";
import {MeetingTranscriptTab} from "../components/MeetingTranscriptTab";
import {MeetingSummaryTab} from "../components/MeetingSummaryTab";
import {MeetingSnowflakeSummaryTab} from "../components/MeetingSnowflakeSummaryTab";
import {MeetingSnowflakeRecommendationsTab} from "../components/MeetingSnowflakeRecommendationsTab";
import {Header} from "../components/Header";

export const Web = () => {

    const dispatch = useDispatch();
    const userCommands = useUserCommands();
    const users = useSelector(state => state.users.users);
    const selectedUserId = useSelector(state => state.users.selectedUserId);
    const meetings = useSelector(state => state.users.meetings);
    const selectedMeetingId = useSelector(state => state.users.selectedMeetingId);
    const [value, setValue] = useState(1);

    useEffect(() => {
        userCommands.loadUsers();
    }, [dispatch]);

    const userSelectionChanged = (e) => {
        userCommands.selectedUserChanged(e.target.value)
    }

    const meetingSelectionChanged = (e) => {
        userCommands.selectedMeetingChanged(e.target.value)
    }

    const signOut = () => {
        dispatch(setAccessToken(null));
    }

    return <>
        <Header signOut={signOut} title="Seismic for Meetings" navigateTo="/Web" />
        <div style={{padding: "16px"}}>
            <div>
                <span className="selectLabel">Host/Attendee</span> &nbsp;
                <select value={selectedUserId} onChange={userSelectionChanged} style={{width: "500px"}}>{users == null ?
                    <option value="" key="userLoading">Loading..</option> : users.map(a => <option key={a.id}
                                                                                                   value={a.id}>{a.name}</option>)}</select>
                &nbsp;<span className="selectLabel">Meeting</span>&nbsp;
                <select value={selectedMeetingId} onChange={meetingSelectionChanged}
                        style={{width: "500px"}}>{meetings == null ?
                    <option value="" key="meetingLoading">Loading..</option> : meetings.map(a => <option key={a.id}
                                                                                                         value={a.id}>{a.title} ({a.daysAgo} ago
                        and was {a.durationSeconds} long)</option>)}</select>
            </div>
            <div>
                <TabsContext value={value}>
                    <TabsList onChange={setValue}>
                        <TabsTab value="1">Meeting Overview</TabsTab>
                        <TabsTab value="2">AIML Summaries</TabsTab>
                        <TabsTab value="3">Meeting Recommendations</TabsTab>
                        <TabsTab value="4">Meeting Summary</TabsTab>
                        <TabsTab value="5">Meeting Transcript</TabsTab>
                        <TabsTab value="6">GPT Analysis</TabsTab>
                        <TabsTab value="7">Microsoft Analysis</TabsTab>
                        <TabsTab value="8">IBM Analysis</TabsTab>
                    </TabsList>
                    <TabsPanel value="1"><MeetingOverviewTab/></TabsPanel>
                    <TabsPanel value="2"><MeetingSnowflakeSummaryTab/></TabsPanel>
                    <TabsPanel value="3"><MeetingSnowflakeRecommendationsTab/></TabsPanel>
                    <TabsPanel value="4"><MeetingSummaryTab/></TabsPanel>
                    <TabsPanel value="5"><MeetingTranscriptTab/></TabsPanel>
                    <TabsPanel value="6"><GptTab/></TabsPanel>
                    <TabsPanel value="7"><MicrosoftTab/></TabsPanel>
                    <TabsPanel value="8"><IbmTab/></TabsPanel>
                </TabsContext>
            </div>
        </div>
    </>;
}